import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How fast can I actually get funded?",
    a: "Most pre-approvals come back the same day you apply. Once you sign the funding agreement, capital is wired to your business account — typically within 24 hours, often the same day for amounts under $250K.",
  },
  {
    q: "What are your minimum requirements?",
    a: "We're flexible. Generally: 6+ months in business, $10K+ monthly revenue, and a U.S. business bank account. We do not require tax returns and will fund applicants that banks have declined.",
  },
  {
    q: "Will applying affect my credit score?",
    a: "No. We only run a soft credit check during pre-qualification, which does not affect your personal credit score. A hard pull only happens with your written consent before funding.",
  },
  {
    q: "How does repayment work?",
    a: "It depends on the product. Merchant Cash Advances are repaid as a small daily or weekly remittance. Term Loans use fixed monthly payments. Lines of credit only charge interest on what you draw. Your specialist will walk you through every option transparently before you sign.",
  },
  {
    q: "Are there hidden fees?",
    a: "Never. Our terms disclose the full payback amount, factor rate or APR, frequency, and any one-time fees up front. If we can't beat your current offer, we'll tell you.",
  },
  {
    q: "What documents do I need?",
    a: "For most pre-approvals: a one-page application and your last 3 months of business bank statements. Larger requests may need additional financials.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-gold mb-5">FAQ</div>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-white tracking-tighter">
              Real answers. No fine print games.
            </h2>
            <p className="mt-6 text-white/60 text-lg">
              Don't see your question? <a href="#apply" className="text-gold hover:text-gold-400 link-underline">Talk to a specialist</a>.
            </p>
          </div>
          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left text-white text-lg font-heading font-medium hover:text-gold py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-white/60 leading-relaxed text-base pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
